import {
  APPOINTMENT_POST,
  APPOINTMENT_POST_CLEAR_DATA,
  APPOINTMENT_POST_ERROR,
  APPOINTMENT_POST_SUCCESS,
  APPOINTMENTACTION_PATCH,
  APPOINTMENTACTION_PATCH_CLEAR_DATA,
  APPOINTMENTACTION_PATCH_ERROR,
  APPOINTMENTACTION_PATCH_SUCCESS,
  APPOINTMENTAVAILABILITY_POST,
  APPOINTMENTAVAILABILITY_POST_CLEAR_DATA,
  APPOINTMENTAVAILABILITY_POST_ERROR,
  APPOINTMENTAVAILABILITY_POST_SUCCESS,
  EXECUTIVELIST_GET,
  EXECUTIVELIST_GET_CLEAR_DATA,
  EXECUTIVELIST_GET_ERROR,
  EXECUTIVELIST_GET_SUCCESS,
  GET_APPOINTMENT,
  GET_APPOINTMENT_ACTION,
  GET_APPOINTMENT_ACTION_CLEAR_DATA,
  GET_APPOINTMENT_ACTION_ERROR,
  GET_APPOINTMENT_ACTION_SUCCESS,
  GET_APPOINTMENT_CLEAR_DATA,
  GET_APPOINTMENT_ERROR,
  GET_APPOINTMENT_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorGetAppointment: null,
  responseGetAppointment: null,
  loadingGetAppointment: false,
  errorGetAppointmentAction: null,
  responseGetAppointmentAction: null,
  loadingGetAppointmentAction: false,
  errorAppointmentActionPatch: null,
  responseAppointmentActionPatch: null,
  loadingAppointmentActionPatch: false,
  errorGetExecutiveList: null,
  responseGetExecutiveList: null,
  loadingGetExecutiveList: false,
  errorGetAppointmentAvailability: null,
  responseGetAppointmentAvailability: null,
  loadingGetAppointmentAvailability: false,
  errorAppointmentPost: null,
  responseAppointmentPost: null,
  loadingAppointmentPost: false,
};

const Appointment = (state = initialState, action) => {
  switch (action.type) {
    case GET_APPOINTMENT:
      state = {
        ...state,
        loadingGetAppointment: true,
        errorGetAppointment: null,
        responseGetAppointment: null,
      };
      break;
    case GET_APPOINTMENT_SUCCESS:
      state = {
        ...state,
        errorGetAppointment: null,
        loadingGetAppointment: false,
        responseGetAppointment: action.payload,
      };
      break;
    case GET_APPOINTMENT_ERROR:
      state = {
        ...state,
        errorGetAppointment: action.payload,
        loadingGetAppointment: false,
        responseGetAppointment: null,
      };
      break;
    case GET_APPOINTMENT_CLEAR_DATA:
      state = {
        ...state,
        errorGetAppointment: null,
        loadingGetAppointment: null,
        responseGetAppointment: false,
      };
      break;
    case GET_APPOINTMENT_ACTION:
      state = {
        ...state,
        loadingGetAppointmentAction: true,
        errorGetAppointmentAction: null,
        responseGetAppointmentAction: null,
      };
      break;
    case GET_APPOINTMENT_ACTION_SUCCESS:
      state = {
        ...state,
        errorGetAppointmentAction: null,
        loadingGetAppointmentAction: false,
        responseGetAppointmentAction: action.payload,
      };
      break;
    case GET_APPOINTMENT_ACTION_ERROR:
      state = {
        ...state,
        errorGetAppointmentAction: action.payload,
        loadingGetAppointmentAction: false,
        responseGetAppointmentAction: null,
      };
      break;
    case GET_APPOINTMENT_ACTION_CLEAR_DATA:
      state = {
        ...state,
        errorGetAppointmentAction: null,
        loadingGetAppointmentAction: null,
        responseGetAppointmentAction: false,
      };
      break;
    case APPOINTMENTACTION_PATCH:
      state = {
        ...state,
        loadingAppointmentActionPatch: true,
        errorAppointmentActionPatch: null,
        responseAppointmentActionPatch: null,
      };
      break;
    case APPOINTMENTACTION_PATCH_SUCCESS:
      state = {
        ...state,
        errorAppointmentActionPatch: null,
        loadingAppointmentActionPatch: false,
        responseAppointmentActionPatch: action.payload,
      };
      break;
    case APPOINTMENTACTION_PATCH_ERROR:
      state = {
        ...state,
        errorAppointmentActionPatch: action.payload,
        loadingAppointmentActionPatch: false,
        responseAppointmentActionPatch: null,
      };
      break;
    case APPOINTMENTACTION_PATCH_CLEAR_DATA:
      state = {
        ...state,
        errorAppointmentActionPatch: null,
        loadingAppointmentActionPatch: null,
        responseAppointmentActionPatch: false,
      };
      break;
    case EXECUTIVELIST_GET:
      state = {
        ...state,
        loadingGetExecutiveList: true,
        errorGetExecutiveList: null,
        responseGetExecutiveList: null,
      };
      break;
    case EXECUTIVELIST_GET_SUCCESS:
      state = {
        ...state,
        errorGetExecutiveList: null,
        loadingGetExecutiveList: false,
        responseGetExecutiveList: action.payload,
      };
      break;
    case EXECUTIVELIST_GET_ERROR:
      state = {
        ...state,
        errorGetExecutiveList: action.payload,
        loadingGetExecutiveList: false,
        responseGetExecutiveList: null,
      };
      break;
    case EXECUTIVELIST_GET_CLEAR_DATA:
      state = {
        ...state,
        errorGetExecutiveList: null,
        loadingGetExecutiveList: null,
        responseGetExecutiveList: false,
      };
      break;
    case APPOINTMENTAVAILABILITY_POST:
      state = {
        ...state,
        loadingGetAppointmentAvailability: true,
        errorGetAppointmentAvailability: null,
        responseGetAppointmentAvailability: null,
      };
      break;
    case APPOINTMENTAVAILABILITY_POST_SUCCESS:
      state = {
        ...state,
        errorGetAppointmentAvailability: null,
        loadingGetAppointmentAvailability: false,
        responseGetAppointmentAvailability: action.payload,
      };
      break;
    case APPOINTMENTAVAILABILITY_POST_ERROR:
      state = {
        ...state,
        errorGetAppointmentAvailability: action.payload,
        loadingGetAppointmentAvailability: false,
        responseGetAppointmentAvailability: null,
      };
      break;
    case APPOINTMENTAVAILABILITY_POST_CLEAR_DATA:
      state = {
        ...state,
        errorGetAppointmentAvailability: null,
        loadingGetAppointmentAvailability: null,
        responseGetAppointmentAvailability: false,
      };
      break;
    case APPOINTMENT_POST:
      state = {
        ...state,
        loadingAppointmentPost: true,
        errorAppointmentPost: null,
        responseAppointmentPost: null,
      };
      break;
    case APPOINTMENT_POST_SUCCESS:
      state = {
        ...state,
        errorAppointmentPost: null,
        loadingAppointmentPost: false,
        responseAppointmentPost: action.payload,
      };
      break;
    case APPOINTMENT_POST_ERROR:
      state = {
        ...state,
        errorAppointmentPost: action.payload,
        loadingAppointmentPost: false,
        responseAppointmentPost: null,
      };
      break;
    case APPOINTMENT_POST_CLEAR_DATA:
      state = {
        ...state,
        errorAppointmentPost: null,
        loadingAppointmentPost: null,
        responseAppointmentPost: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default Appointment;
